import { useEffect, useState } from 'react'

export type BanderoleCountDown = {
  isReady: boolean
  expired: boolean
  days: string
  hours: string
  minutes: string
  seconds: string
}

const zeroPad = (num: number, places: number) => String(num).padStart(places, '0')

const useCountdownData = ({
  isBanderoleVisible,
  banderoleData,
  rerenderCondition,
}: {
  isBanderoleVisible?: boolean
  banderoleData?: any
  rerenderCondition?: any
}): BanderoleCountDown => {
  const [countdownData, setCountdownData] = useState<BanderoleCountDown>({
    isReady: false,
    expired: false,
    days: '00',
    hours: '00',
    minutes: '00',
    seconds: '00',
  })

  useEffect(() => {
    let countdownInterval: ReturnType<typeof setInterval> | undefined
    if (isBanderoleVisible) {
      const countDownDate = new Date(banderoleData).getTime()
      const currentTime = new Date().getTime()
      const isValid = countDownDate - currentTime > 0 ? true : false

      setCountdownData({
        ...countdownData,
        isReady: isValid,
        expired: !isValid,
      })

      if (!isValid) return

      countdownInterval = setInterval(() => {
        const now = new Date().getTime()
        const distance = countDownDate - now

        setCountdownData({
          isReady: distance > 0,
          expired: distance <= 0,
          days: zeroPad(Math.floor(distance / (1000 * 60 * 60 * 24)), 2),
          hours: zeroPad(Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)), 2),
          minutes: zeroPad(Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60)), 2),
          seconds: zeroPad(Math.floor((distance % (1000 * 60)) / 1000), 2),
        })

        if (distance <= 0) clearInterval(countdownInterval)
      }, 1000)
    }

    return () => {
      if (countdownInterval) {
        clearInterval(countdownInterval)
      }
    }
  }, [rerenderCondition])

  return countdownData
}

export default useCountdownData
